import React, {useState, useEffect} from 'react'
import Modal from 'components/utils/Modal'
import SearchBar from 'components/utils/SearchBar'
import Icon from 'components/utils/Icon'

const Description = (props) => {

  const [fetchedData, setFetchedData] = useState([])
  const [searchValue, setSearchValue] = useState('')

  const fetchData = () => {

    fetch('/api/selectMenuDescription', {
      method: 'post',
      headers: {
        'Accept': 'application/json, text/plain, */*',
        'Content-Type': 'application/json'
      }
    })
    .then(res=>res.json())
    .then(
      (result) => {
        //console.log('result: ' + result)
        setFetchedData(result)
      },
      (error) => {
        console.log('Error: selectMenuDescription --> ' + error)
      }
    )

  }

  useEffect(() => {
    fetchData()
  }, [])

  const search = (e) => {
    let value = e.target.value
    setSearchValue(value)
  }

  const clearSearch = () => {
    document.getElementById('searchInput').value = ''
    setSearchValue('')
  }

  const viewExplanation = () => window.open('Explanation.pdf')

  let listOfData = fetchedData.map(data => {

    let description = data.description === null ? '' : data.description

    if (searchValue === '' || description.toLowerCase().indexOf(searchValue.toLowerCase()) >= 0) {
      return (
        <tr key={data.id.toString()} onClick={props.selectDescription}>
          <td>{description}</td>
        </tr>
      )
    }

  })

  let content = (
    <div>

      <SearchBar search={search} clearSearch={clearSearch} />

      <div>

        <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: 'white', borderRadius: 5}}>
          <Icon name='help_outline' onClick={viewExplanation} /><span style={{marginRight: 10}}>View how to classify</span>
        </div>

        <div style={{display: 'inline-block', textAlign: 'center', marginTop: 10}}>

          <table>

            <thead>
              <tr>
                <th>Descrip</th>
              </tr>
            </thead>

            <tbody>
              {listOfData}
            </tbody>

          </table>

        </div>

      </div>

    </div>
  )

  return <Modal content={content} close={props.close} />
}

export default Description
